import { render, staticRenderFns } from "./FooterLine.vue?vue&type=template&id=3757554d&scoped=true&"
import script from "./FooterLine.vue?vue&type=script&lang=ts&"
export * from "./FooterLine.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLine.vue?vue&type=style&index=0&id=3757554d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757554d",
  null
  
)

export default component.exports